import { render, staticRenderFns } from "./EventHistoryView.vue?vue&type=template&id=7213af4c&scoped=true&"
import script from "./EventHistoryView.vue?vue&type=script&lang=ts&"
export * from "./EventHistoryView.vue?vue&type=script&lang=ts&"
import style0 from "./EventHistoryView.vue?vue&type=style&index=0&id=7213af4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213af4c",
  null
  
)

export default component.exports